//import config from "../config/index.js";
import api from "./axiosClient.js";

/** Code after implementation of axios client */

export const loginApi = async (data) => {
  const res = await api.post("/login", data);
  return res.data;
};


export const getProfile = async () => {
  const res = await api.get("/profile");
  return res.data;
};

export const logoutApi = async () => {
  const res = await api.post("/logout");
  return res.data;
};

/* Code before implementation of axios client

export const loginApi = async (data) => {
    console.log("API URL: ", config.API_URL, process.env.API_URL);
  const res = await fetch(`${config.API_URL}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  return res.json();
};
*/